import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  createRecaptchaScript(lang: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    const recaptchaScript = this.document.createElement('script');
    recaptchaScript.id = 'recaptcha-script';
    recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${lang}`;
    recaptchaScript.type = 'text/javascript';
    head.appendChild(recaptchaScript);
  }
}
